import React from 'react'

import { responsibleUseHeader, ResponsibleUseItems, responsibleUseTip } from './constants'

import s from './styles.module.scss'

const ResponsibleUse = () => {
  const WarningIcon = responsibleUseHeader.icon
  const TipIcon = responsibleUseTip.icon
  return (
    <aside className={s.card} aria-labelledby="responsible-use-title">
      <header className={s.header}>
        <div className={s.headerIcon}>
          <WarningIcon fontSize="medium" aria-hidden="true" />
        </div>
        <div className={s.headerText}>
          <h3 id="responsible-use-title" className={s.title}>
            {responsibleUseHeader.title}
          </h3>
          <p className={s.subtitle}>{responsibleUseHeader.subtitle}</p>
        </div>
      </header>

      <p className={s.sectionLabel}>Prácticas que pueden generar el bloqueo de tu número</p>

      <ul className={s.list}>
        {ResponsibleUseItems.map(({ Icon, title, body }, i) => (
          <li key={title} className={s.item}>
            <span className={s.itemIcon} aria-hidden="true">
              <Icon fontSize="small" />
            </span>
            <div className={s.itemContent}>
              <p className={s.itemTitle}>{title}</p>
              <p className={s.itemBody}>{body}</p>
            </div>
          </li>
        ))}
      </ul>

      <div className={s.tip}>
        <TipIcon className={s.tipIcon} fontSize="small" aria-hidden="true" />
        <p className={s.tipText}>{responsibleUseTip.text}</p>
      </div>
    </aside>
  )
}

export default ResponsibleUse
